import React from "react";
import { useQuery } from "@apollo/client/react";
import { ASSETS_COLLECTION_INVENTORY_MOVE_QUERY } from "../../../constants/graphql/queries";
import useQueryParams from "src/hooks/useQueryParams";
import ShipmentErrorModal from "./ShipmentErrorModal";
import ItemNotFoundModal from "./ItemNotFoundModal";
import ItemInventoryMove from "./ItemInventoryMove";
import LoadingDialog from "./LoadingDialog";
import ConfirmMoveToSelectedLocationModal from "./ConfirmMoveToSelectedLocationModal";

export const ItemInventoryMoveContext = React.createContext();

export default function MoveByItemIdModal({ code, onClose }) {
  const params = useQueryParams();
  const movedAssetIds = params.get("movedAssetIds");
  const newRackLocation = params.get("newRackLocation");

  const { loading, error, data } = useQuery(ASSETS_COLLECTION_INVENTORY_MOVE_QUERY, {
    variables: { 
      itemId: code,
      order: { item_id: "desc" },
      type: "Asset"
    },
    skip: !code,
  });
  const assets = data?.assetsCollection?.collection || [];
  const [asset] = assets;

  if (loading) {
    return <LoadingDialog onClose={onClose} />;
  }

  if (error) {
    return <ShipmentErrorModal onClose={onClose} errorMessage={error.message} />;
  }

  if (!asset) {
    return <ItemNotFoundModal onClose={onClose} />;
  }

  if (movedAssetIds && newRackLocation && asset?.rackLocations?.length === 1) {
    return <ConfirmMoveToSelectedLocationModal asset={asset} />;
  }

  return <ItemInventoryMove data={data} onClose={onClose} />;
}